import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@next/core-lib/authentication';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  standalone: false,
})
export class UnauthorizedComponent {
  constructor(
    private readonly router: Router,
    private readonly authentication: AuthenticationService,
  ) {}

  logout() {
    this.authentication.logout();
    this.router.navigate(['/']);
  }
}
